export const getUserInfo = (accessToken) => {
  return fetch(
    `${window.location.origin}/particuliers/auto/assurance-auto-usage/espace-client/api/on-demand/userinfo?accessToken=${accessToken}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }
  ).then(response => response.json())
  .then(data => data[0])
}

export const getUserInfoContract = (accessToken, email) => {
  return fetch(
    `${window.location.origin}/particuliers/auto/assurance-auto-usage/espace-client/api/on-demand/user-info-contract`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        mail: email,
        productKey: "autoUsage",
      }),
    }
  ).then(response => response.json())
  .then(data => data[0])
}